import { render, staticRenderFns } from "./BatchDialog.vue?vue&type=template&id=5213cd92&scoped=true&"
import script from "./BatchDialog.vue?vue&type=script&lang=ts&"
export * from "./BatchDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5213cd92",
  null
  
)

export default component.exports